module.exports = __webpack_public_path__ + "img/bsbyssf.cbdcde61.png";